import React, { ComponentType, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/App/hooks';
import { getAboutAuthorThunk } from '@/features/i18n/i18nSlice';
import { selectLocale } from '@/features/i18n/selectLocale';
import { selectResources } from '@/features/i18n/selectResources';

export interface WithAboutAuthorTextProps {
  text: string;
}

export const withAboutAuthorText = <T extends object>(
  WrappedComponent: ComponentType<T & WithAboutAuthorTextProps>,
) => {
  const HOC = (props: T) => {
    const dispatch = useAppDispatch();
    const locale = useAppSelector(selectLocale);
    const resources = useAppSelector(selectResources);
    const { aboutAuthor } = resources;

    useEffect(() => {
      if (!aboutAuthor.initialized && locale) {
        dispatch(getAboutAuthorThunk(locale));
      }
    }, [dispatch, aboutAuthor, locale]);

    if (!aboutAuthor.initialized || !locale) {
      return null;
    }

    return <WrappedComponent text={aboutAuthor.text} {...props} />;
  };
  HOC.displayName = `withAboutAuthorText(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return HOC;
};
